import {
  ADMISSION_DELETE_CATEGORY,
  ADMISSION_UPDATE_CATEGORY,
  KNOWLEDGE_DELETE_ITEM,
  KNOWLEDGE_UPDATE_ITEM,
  LAB_DELETE_ITEM,
  LAB_UPDATE_ITEM,
  ORGANIZATION_SWITCH,
  SEARCH_ON_CHANGE,
  SEARCH_RESULTS,
} from '../actions';
import { forceNewSearch } from '../actions/search.actions';
import { search } from '../selectors/search.selector';
import { isSearchV2Enabled } from '../selectors/features.selector';
import searchServiceAPI from '../../api/search.service.api';
import {
  assembleResultsFromApiGroups,
  emptyResultsShape,
  mapFiltersToApi,
} from '../../utils/search-v2-mapper';
import { SEARCH_V2_FETCH_LIMIT } from '../../constants/search.constants';

export const fetchSearchResultsMiddleware =
  ({ dispatch, getState }) =>
  next =>
  async action => {
    next(action);

    if (action.type !== SEARCH_ON_CHANGE) return;

    const { term, force, filters } = action.payload;

    if (!force && term === '') {
      return dispatch({ type: SEARCH_RESULTS, payload: { results: null } });
    }

    const state = getState();

    if (!isSearchV2Enabled(state)) {
      return dispatch({
        type: SEARCH_RESULTS,
        payload: search(state, term, filters),
      });
    }

    const requestTerm = term;
    const apiResp = await searchServiceAPI
      .search({
        query: term,
        filters: mapFiltersToApi(filters),
        groupBy: 'workspace',
        limit: SEARCH_V2_FETCH_LIMIT,
      })
      .catch(error => ({ success: false, error }));

    // Drop stale response — a newer term has already been dispatched.
    if (getState().search.term !== requestTerm) return;

    if (!apiResp?.success) {
      console.warn('[search-v2] request failed', apiResp?.error);
      return dispatch({
        type: SEARCH_RESULTS,
        payload: { results: emptyResultsShape(), hasError: true },
      });
    }

    return dispatch({
      type: SEARCH_RESULTS,
      payload: {
        results: assembleResultsFromApiGroups({
          groups: apiResp.data?.groups,
          facets: apiResp.data?.facets,
          count: apiResp.data?.count,
          state,
        }),
      },
    });
  };

export const forceSearchUpdateItemUpdatedMiddleware =
  ({ dispatch }) =>
  next =>
  async action => {
    next(action);

    if (
      action.type === KNOWLEDGE_UPDATE_ITEM ||
      action.type === KNOWLEDGE_DELETE_ITEM ||
      action.type === LAB_UPDATE_ITEM ||
      action.type === LAB_DELETE_ITEM ||
      action.type === ADMISSION_DELETE_CATEGORY ||
      action.type === ADMISSION_UPDATE_CATEGORY
    ) {
      dispatch(forceNewSearch());
    }
  };

const clearSearchResultsMiddleware =
  ({ dispatch }) =>
  next =>
  async action => {
    if (action.type === ORGANIZATION_SWITCH) {
      dispatch({
        type: SEARCH_ON_CHANGE,
        payload: { results: null, initialResults: null, term: '' },
      });
    }
    next(action);
  };

export const searchMiddleware = [
  fetchSearchResultsMiddleware,
  forceSearchUpdateItemUpdatedMiddleware,
  clearSearchResultsMiddleware,
];
